<template>
<div>
    <div class="main-body desktop">
        <div class="circles">
            <div class="big-circle"></div>
            <div class="medium-circle"></div>
            <div class="small-circle"></div>
        </div>
        <div class="site-header">
            <router-link class="brand p-2" to="/">
                <img class="logo-img" :src="logo.src" alt="" />
            </router-link>
        </div>
        <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" class="form-box">
                <p>Sign Up</p>
                <p>Please register your account</p>
                <form @submit.prevent="submit" class="form-container">
                    <b-form-group class="col-md-12 mb-3" label-for="input-1">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon shift-h="-4" icon="person"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input :state="$v.username.required" v-model.trim="$v.username.$model" type="text" placeholder="Username "></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.username.minLength" id="input-live-feedback">
                            Username must have at least {{ $v.username.$params.minLength.min }} letters.
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.username.maxLength">
                            Username must have at most
                            {{ $v.username.$params.maxLength.max }} letters.
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="col-md-12 mb-3" label-for="input-1">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon shift-h="-4" icon="envelope"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input :state="$v.email.required" v-model.trim="$v.email.$model" type="email" placeholder="Email "></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.email.email">email must have the right format </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon shift-h="-4" icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input :state="$v.password.required" v-model.trim="$v.password.$model" :type="password_type" placeholder="Password"></b-form-input>
                            <b-input-group-append is-text>
                                <b-icon class="eye-con" @click="showPassword" shift-h="-4" icon="eye-slash"></b-icon>
                            </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.password.minLength">Minimum
                            {{ $v.password.$params.minLength.min }} characters.</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon shift-h="-4" icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model.trim="$v.repeatPassword.$model" :type="confirm_password_type" placeholder="Confirm Password"></b-form-input>
                            <b-input-group-append is-text>
                                <b-icon class="eye-con" @click="showConfirmPassword" shift-h="-4" icon="eye-slash"></b-icon>
                            </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</b-form-invalid-feedback>
                    </b-form-group>
                    <div>
                        <b-form-checkbox v-model.trim="$v.terms.$model" v-model="terms" id="termsCheckbox">
                            I agree to the <router-link to="/terms">Terms & Conditions</router-link>
                        </b-form-checkbox>
                    </div>
                    <b-form-group class="col-md-12 button-contain mb-3" label-for="input-1">
                        <button :disabled="loading" class="btn btn-warning">{{btnText}}
                            <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                    </b-form-group>
                    <p>
                        Existing Customer? <router-link to="/accounts/signin">Login</router-link>
                    </p>
                </form>
            </b-col>
        </b-row>
        <div class="foot-text">
            <p>Welcome to Culture Square</p>
            <ul class="ml-2">
                <li>Sell</li>
                <li>Buy</li>
                <li>Host Events</li>
                <li>Attend Events</li>
            </ul>
        </div>

    </div>
    <div class="mobile">
        <AbstractHeader />
        <div class="form-box">
            <p>Sign Up</p>
            <p>Please register your account</p>
            <form @submit.prevent="submit" class="form-container">
                <b-form-group class="col-md-12 mb-3" label-for="input-1">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="person"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input :state="$v.username.required" v-model.trim="$v.username.$model" type="text" placeholder="Username "></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback v-if="!$v.username.minLength" id="input-live-feedback">
                        Username must have at least {{ $v.username.$params.minLength.min }} letters.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.username.maxLength">
                        Username must have at most
                        {{ $v.username.$params.maxLength.max }} letters.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group class="col-md-12 mb-3" label-for="input-1">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="envelope"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input :state="$v.email.required" v-model.trim="$v.email.$model" type="email" placeholder="Email "></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback v-if="!$v.email.email">email must have the right format </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input :state="$v.password.required" v-model.trim="$v.password.$model" :type="password_type" placeholder="Password"></b-form-input>
                        <b-input-group-append is-text>
                            <b-icon class="eye-con" @click="showPassword" shift-h="-4" icon="eye-slash"></b-icon>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback v-if="!$v.password.minLength">Minimum
                        {{ $v.password.$params.minLength.min }} characters.</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                    <b-input-group class="">
                        <b-input-group-prepend is-text>
                            <b-icon icon="lock"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input v-model.trim="$v.repeatPassword.$model" :type="confirm_password_type" placeholder="Confirm Password"></b-form-input>

                        <b-input-group-append is-text>
                            <b-icon class="eye-con" @click="showConfirmPassword" shift-h="-4" icon="eye-slash"></b-icon>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</b-form-invalid-feedback>

                </b-form-group>
                <div>
                    <b-form-checkbox v-model.trim="$v.terms.$model" v-model="terms" id="termsCheckbox">
                        I agree to the <router-link to="/terms">Terms & Conditions</router-link>
                    </b-form-checkbox>
                </div>
                <b-form-group class="col-md-12 button-contain mb-3" label-for="input-1">
                    <button :disabled="loading" class="btn btn-warning">{{btnText}}
                        <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                </b-form-group>
                <p>
                    Existing Customer? <router-link to="/accounts/signin">Login</router-link>
                </p>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import AbstractHeader from "@/components/AbstractHeader.vue";
import { getLogoUrl } from "../../../utils/common";

import {
    required,
    sameAs,
    minLength,
    maxLength,
    email
} from "vuelidate/lib/validators";
export default {
    name: 'sign-in',
    data: function () {
        return {
            loading: false,
            username: "",
            email: "",
            password: "",
            repeatPassword: "",
            submitStatus: null,
            btnText: "Sign Up",
            errormessage: '',
            error: false,
            terms: false,
            password_type: 'password',
            confirm_password_type: 'password',
            logo: {}
        }
    },
    validations: {
        username: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(25)
        },
        terms: {
            required
        },
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(8)
        },
        repeatPassword: {
            sameAsPassword: sameAs("password")
        }
    },
    components: {
        AbstractHeader
    },
    created() {
        this.logo = getLogoUrl(); // Generate the logo object
    },
    methods: {
        async submit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = "ERROR";
            } else {
                this.btnText = "Registering...";
                this.loading = true
                if (this.email && this.password && this.terms) {
                    try {
                        await this.$store
                            .dispatch("register", {
                                username: this.username,
                                email: this.email,
                                password: this.password
                            })
                        this.loading = false
                        this.btnText = "Sign Up";
                        this.$router.push("/accounts/verify");

                    } catch (err) {
                        this.loading = false
                        this.btnText = "Sign Up";
                        if (err.response.status !== "200") {
                            this.$root.$refs.A.makeToast('danger', err.response.data.message)

                        }
                    }

                } else {
                    this.loading = false
                    this.btnText = "Sign Up";
                    alert('Accept the terms and conditions')
                }
            }
        },
        showPassword() {
            if (this.password_type === 'password') {
                this.password_type = 'text'
            } else {
                this.password_type = 'password'
            }
        },
        showConfirmPassword() {
            if (this.confirm_password_type === 'password') {
                this.confirm_password_type = 'text'
            } else {
                this.confirm_password_type = 'password'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    background-image: url('../../assets/images/abstract.svg');
    background-repeat: no-repeat;
}

.eye-con {
    cursor: pointer
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.logo-img {
    position: fixed;
    width: 8%
}

.site-header {
    padding: 30px 50px;
}

.circles {
    position: absolute
}

.big-circle {
    position: relative;
    left: 191%;
    top: -58px;
    height: 190px;
    width: 190px;
    border-radius: 50%;
    background: #F7B131;
}

.medium-circle {
    position: relative;
    left: 295%;
    top: -90px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background: #F7B131;
}

.small-circle {
    position: relative;
    left: 300%;
    top: -50px;
    height: 62px;
    width: 62px;
    border-radius: 50%;
    background: #F7B131;
}

.form-container {
    background: none;
    box-shadow: none;
    padding: 30px 15px 15px 0px !important;
}

a {
    color: #F7B131;
}

.form-box {
    padding: 20px 75px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 40px 20px 20px 20px;
    }
}

.form-box p:first-child {
    font-size: 28px;
    border-bottom: 1px solid #E0E0E0;
}

.foot-text {
    color: #fff;
    position: fixed;
    bottom: 0;
    padding-bottom: 1rem
}

.foot-text p {
    padding-left: 2.5rem;
    font-size: 14px
}

.foot-text ul {
    display: flex
}

.foot-text ul>li {
    margin: 0 10px;
}

.button-contain {
    margin-top: 40px;

}

.button-contain button {
    width: 100%
}

.svg-inline--fa {
    height: 0.7em !important
}

@media screen and (min-width: 1400px) {
    .main-body {
        height: 100vh;
    }

    .big-circle {
        position: relative;
        left: 191%;
        top: -58px;
        height: 211px;
        width: 211px;
        border-radius: 50%;
        background: #F7B131;
    }

    .medium-circle {
        position: relative;
        left: 285%;
        top: -90px;
        height: 129px;
        width: 129px;
        border-radius: 50%;
        background: #F7B131;
    }

    .small-circle {
        position: relative;
        left: 280%;
        top: -50px;
        height: 62px;
        width: 62px;
        border-radius: 50%;
        background: #F7B131;
    }
}
</style>
